import { signal } from '@preact/signals-react';

const appState = signal({
	ExhibitionInfo: false,
	ExhibitorList: false,
	MyFavourites: false,
	ExhibitorInfo: false,
	SearchPanel: false,
	MobileMenu: false,
	activeFloor: 0,
	selectedBooth: null,
	selectedExhibitor: null,
	selectedProduct: null,
	exhibitorSection: null,
	navigation: false,
	currentNavStart: null,
	loading: true,
	RecommendedRoutes: false,
	activeRoute: null,
	RouteSharePopup: null,
});

export default appState;